<script>
import Vue from 'vue'
import { MODAL, RELOAD } from '@constants/Text'
import { GlobalBus } from '@services/bus'
import { apiConsolidatorClientAssets } from '@modules/consolidator/api/apiConsolidatorClientAssets'

export default {
  name: 'ConsolidatorRemoverProduto',
  data() {
    return {
      busModal: new Vue(),
      ativo: {},
      idClienteFromPayload: '',
      loadingDeleteN: false,
      loadingDeleteY: false,
    }
  },
  computed: {
    tiposComExtrato() {
      return new Set(['FII', 'Ação', 'Ações', 'Renda Fixa'])
    },
    idCliente() {
      if (this.idClienteFromPayload) return this.idClienteFromPayload
      const client = this.$store.getters['user/currentClient'] || {}
      return client.id || ''
    },
    isCliente() {
      return !!this.$currentUser().IS_CLIENTE
    },
  },
  created() {
    GlobalBus.$on(MODAL.REMOVE_PRODUCT, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.REMOVE_PRODUCT, this.open)
  },
  methods: {
    open({ ativo, idCliente } = {}) {
      this.clear()
      this.ativo = ativo || {}
      this.idClienteFromPayload = idCliente || ''
      this.busModal.$emit('dialog', true)
    },
    clear() {
      this.ativo = {}
      this.idClienteFromPayload = ''
      this.loadingDeleteN = false
      this.loadingDeleteY = false
    },
    async remover(limparExtrato, close) {
      if (this.loadingDeleteN || this.loadingDeleteY) return

      const ativo = this.ativo
      if (this.tiposComExtrato.has(ativo.Tipo) && limparExtrato === '0') {
        GlobalBus.$emit(MODAL.REMOVE_ASSET, ativo)
        close()
        return
      }

      this.setLoading(limparExtrato, true)
      const r = await apiConsolidatorClientAssets.removeAsset({
        ativo,
        idCliente: this.idCliente,
        isCliente: this.isCliente,
        limparExtrato,
      })
      this.handleRemoveResponse(r)
      this.setLoading(limparExtrato, false)
      close()
    },
    setLoading(limparExtrato, value) {
      if (limparExtrato === '0') {
        this.loadingDeleteN = value
      } else {
        this.loadingDeleteY = value
      }
    },
    handleRemoveResponse(r) {
      if (r && r.status === 200) {
        this.$showSnack({
          text: 'Exclusão realizada com sucesso',
          button: true,
        })
        GlobalBus.$emit(RELOAD.ASSETS_ONLY, true)
        return
      }
      this.$showSnack({
        text: (r && r.message) || 'Exclusão inválida',
        button: true,
      })
    },
  },
}
</script>

<template>
  <BaseModal
    centerScreen
    :bus="busModal"
    persistent
    centerAndDecreasesPadding
    maxWidth="500px"
    closeColor="#8e8e8e"
    backgroundColor="white"
  >
    <div class="remover-produto pb-6">
      <div class="modal-title-container">
        <span class="modal-title">Excluir ativo</span>
      </div>

      <div class="modal-content">
        <p>Escolha o que fazer com o histórico deste ativo:</p>

        <div class="remover-produto__opcao">
          <icon-svg name="mdi-history" :size="18" color="#8E8E8E" />
          <div>
            <span class="remover-produto__rotulo">
              <strong>Manter histórico</strong>
              <v-tooltip bottom max-width="320">
                <template v-slot:activator="{ on, attrs }">
                  <icon-svg
                    name="mdi-information"
                    size="14"
                    color="#8E8E8E"
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <span>
                  Use quando a posição foi encerrada de verdade: o cliente
                  vendeu, resgatou ou o título venceu. A rentabilidade do
                  período continua correta, porque o histórico fica.
                </span>
              </v-tooltip>
            </span>
            A posição é zerada e o ativo continua na carteira com saldo R$ 0,00.
            Os aportes e resgates continuam no extrato e seguem contando na
            rentabilidade. Em alguns tipos, pediremos o preço final antes de
            concluir.
          </div>
        </div>

        <div class="remover-produto__opcao">
          <icon-svg name="mdi-delete-outline" :size="18" color="#8E8E8E" />
          <div>
            <span class="remover-produto__rotulo">
              <strong>Excluir tudo</strong>
              <v-tooltip bottom max-width="320">
                <template v-slot:activator="{ on, attrs }">
                  <icon-svg
                    name="mdi-information"
                    size="14"
                    color="#8E8E8E"
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <span>
                  Use quando o ativo foi cadastrado por engano e nunca existiu
                  na carteira. Se ele existiu de verdade, apagar o histórico
                  distorce a rentabilidade do período.
                </span>
              </v-tooltip>
            </span>
            O ativo e todo o histórico (aportes, resgates, proventos e eventos)
            são apagados permanentemente. Não é possível desfazer.
          </div>
        </div>

        <p v-if="!isCliente" class="az-text-small mt-4">
          Para tirar o ativo apenas do cálculo de rentabilidade, sem perder
          nada, use "Desconsiderar na rentabilidade" nas ações em lote.
        </p>
      </div>
    </div>

    <template v-slot:actions="{ close }">
      <BaseButton underlined @click="close"> Cancelar </BaseButton>
      <BaseButton
        outline
        dark
        :loading="loadingDeleteN"
        @click="remover('0', close)"
      >
        Manter histórico
      </BaseButton>
      <BaseButton alert :loading="loadingDeleteY" @click="remover('1', close)">
        Excluir tudo
      </BaseButton>
    </template>
  </BaseModal>
</template>

<style lang="sass" scoped>
.remover-produto
  &__opcao
    display: grid
    grid-template-columns: 18px 1fr
    align-items: start
    gap: 8px
    margin-top: 12px

    > *:first-child
      margin-top: 2px

  &__rotulo
    display: flex
    align-items: center
    gap: 4px

    ::v-deep .v-tooltip
      display: contents
</style>
